import React from "react";
import { OmModal } from "@om/component-library-react";

const FieldDetailModal = ({ title, content }) => {
  return (
    <OmModal
      overlayName="field-details"
      hasContinueButton={true}
      isCentered={true}
    >
      <div slot="modal-content">
        <h4 className="show-text-two">{title}</h4>
        <p className="result-modal-text-two">{content}</p>
      </div>
    </OmModal>
  );
};

export default FieldDetailModal;
